export default __webpack_public_path__ + "static/media/480_dummy2016-illustrator01-de.138a1bb8.png";